import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: '/images/placeholder.svg',
    attempt: 2,
    observer: true,
    observerOptions: {
        rootMargin: '0px',
        threshold: 0.1,
    },
    throttleWait: 500,
    listenEvents: ['scroll'],
    lazyComponent: true,
})
